import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import BidModal from "./auctionLot/BidModal";

const AuctionLotBidsDialog = React.memo((props) => {
  const handleClose = () => {
    props.handleAuctionDialog({});
  };

  return (
    <Dialog
      open={props.activeDialog}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={"lg"}
    >
      <DialogTitle id="alert-dialog-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>Bid Logs {props.lotDetails?.lotNumber ? `- Lot ${props.lotDetails.lotNumber}` : ""}</span>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {props.lotDetails && (
          <BidModal
            eventId={props.lotDetails.eventId}
            eventItemId={props.lotDetails.eventItemId}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default AuctionLotBidsDialog;
